<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
export default {
    name: 'App',

    created(){

    },

    data() {
        return{

        }
    },

    methods: {

    }

}
</script>

<style lang="less">
    @import './common/less/index.less';
    #app{
        width: 100%;
    }
</style>



// WEBPACK FOOTER //
// src/App.vue